export const dateRangeSliderConfig = {
    outOfViewGrayLightness: 32,
    outOfViewOpacity: 0.33,
    zoomFactor: 0.15,
    minViewMonths: 2,
    buttonPanMonths: 3,
}
